import React from 'react'
import { Header, BoxFechar, BoxConteudo, BoxTexto, PreTitulo, Titulo, Tag, Texto } from './Styled'
import imgFechar from 'images/ic-fechar-promocao-ecj.svg'
import imgCabecalho from 'images/imagem-renovacao-antecipada.jpg'
import routes from 'config/routes'
import { NavLink } from 'react-router-dom'
import { dateNotYear } from 'utils/formatters'

export default function Cabecalho ({ dados }) {

  // const [preTitulo, setAviso] = useState(dados.assinatura_atual ? dados.assinatura_atual.delta : false)

  const getTextos = () => {

    let textos = {};

    if (dados.tipo === 'TSE') {

      textos = {
        'preTitulo': 'Oferta Exclusiva para alunos do <strong>TSE Unificado</strong>',
        'titulo': 'Assinatura Premium',
        'tag': 'com 40% de desconto!',
        'texto': 'Torne-se assinante até o dia 23 de dezembro de 2024 e economize até R$ 2.041,85'
      }

    } else if (dados.tipo === 'Correios') {
      
      textos = {
        'preTitulo': 'Oferta Exclusiva para alunos do <strong>Correios</strong>',
        'titulo': 'Assinatura Premium',
        'tag': 'com 40% de desconto!',
        'texto': 'Torne-se assinante até o dia 31 de dezembro de 2024 e economize até R$ 2.041,85'
      }

    } else if (dados.tipo === 'TJ-SP') {
      
      textos = {
        'preTitulo': 'Oferta Exclusiva para alunos do <strong>TJ-SP</strong>',
        'titulo': 'Assinatura Premium',
        'tag': 'com 40% de desconto!',
        'texto': 'Torne-se assinante até o dia 31 de dezembro de 2024 e economize até R$ 2.041,85'
      }

    } else {

      if (dados.produto_atual) {

        textos = {
          'preTitulo': 'Promoção',
          'titulo': 'Renovação Antecipada',
          'tag': dados.desconto_ate + '% off até 02/01',
          'texto': 'Até o dia 02/01, você garante até ' + dados.desconto_ate + '% de desconto para renovar a<br /> sua assinatura atual ou fazer um upgrade de plano!'
        }

      }

    }

    return textos;

  }

  return (
    <Header>

      <BoxFechar>
        <NavLink to={routes.cursos}>
          <img src={imgFechar} alt="Fechar" />
        </NavLink>
      </BoxFechar>

      <BoxConteudo>

        {/* Texto */}
        <BoxTexto>
          <PreTitulo dangerouslySetInnerHTML={{ __html: getTextos().preTitulo }} />
          <Titulo dangerouslySetInnerHTML={{ __html: getTextos().titulo }} />
          <Tag dangerouslySetInnerHTML={{ __html: getTextos().tag }} />
          <Texto dangerouslySetInnerHTML={{ __html: getTextos().texto }} />
        </BoxTexto>

        <img src={imgCabecalho} alt="Cabecalho" />

      </BoxConteudo>

    </Header>
  )
}
